import __isEmpty from 'lodash/isEmpty';

const parseColor = (d) => `rgb(${d.rcolor}, ${d.gcolor}, ${d.bcolor})`;

const getDataDiputats = (dataDiputats, extraParams) => {
    const dataString = [];
    const dataNum = [];
    const labels = [];
    const colors = [];
    if (__isEmpty(dataDiputats?.datos?.geo?.opcions?.item)) {
        return {
            dataString,
            dataNum,
            labels,
            colors
        };
    }

    if (extraParams.fase === 'seo' && !extraParams.isSecondary) {
        return {
            dataString,
            dataNum: [1],
            labels,
            colors: ['#f0f3f4'],
            total: dataDiputats?.datos.geo?.num_items_total,
            escrutini: dataDiputats?.datos.geo?.perc_escrutat,
            noData: true
        };
    }

    dataDiputats.datos.geo.opcions.item.forEach((d) => {
        if (extraParams?.mostrarPartitsSenseDiputats || d.mnumitems > 0) {
            dataString.push(d.numitems);
            dataNum.push(d.mnumitems);
            labels.push(d.id);
            colors.push(parseColor(d));
        }
    });
    return {
        dataString,
        dataNum,
        labels,
        colors,
        total: dataDiputats?.datos.geo?.num_items_total,
        escrutini: dataDiputats?.datos.geo?.perc_escrutat
    };
};

const getDataEvolucioPartitsLinea = (dataPartits) => {
    let data = [];
    let labels = [];
    if (!dataPartits) return { data, labels };

    labels = Object.keys(dataPartits).sort();
    const series = {};
    const lastColorByParty = {};

    labels.forEach((year, i) => {
        const yearData = dataPartits[year];
        if (yearData.partits) {
            yearData.partits.forEach((p) => {
                const id = p.id;
                const value = Number(p.perc) || undefined;

                if (!series[id]) {
                    series[id] = Array(labels.length).fill(undefined);
                }
                series[id][i] = value;

                lastColorByParty[id] = p.rgbcolor;
            });
        } else {
            Object.keys(series).forEach((id) => {
                series[id][i] = undefined;
            });
        }
    });

    Object.entries(series).forEach(([id, values]) => {
        for (let i = 1; i < values.length - 1; i++) {
            if (values[i] === undefined && values[i - 1] !== undefined && values[i + 1] !== undefined) {
                values[i] = 0;
            }
        }
    });

    const lastYear = labels.reverse().find((year) => {
        const yearData = dataPartits[year];
        return yearData?.partits?.some((p) => p.perc !== undefined && p.perc !== null && p.perc !== 0);
    });

    const partitsLastYear = dataPartits[lastYear]?.partits?.map((p) => p.id) || [];

    data = Object.entries(series)
        .filter(([id, values]) => partitsLastYear.includes(id) && values.some((v) => v !== undefined && v >= 1))
        .map(([id, values]) => ({
            label: id,
            data: values.map((v) => (v !== undefined ? Number(v) : undefined)),
            spanGaps: false,
            fill: false,
            borderColor: lastColorByParty[id] || '#000000',
            pointBackgroundColor: lastColorByParty[id] || '#000000',
            pointBorderColor: lastColorByParty[id] || '#000000',
            pointRadius: function (context) {
                const index = context.dataIndex;
                const dataset = context.dataset;
                if (dataset.data[index] !== undefined && dataset.data[index] !== null) {
                    const lastIndexWithData = dataset.data
                        .map((value, idx) => (value !== undefined && value !== null ? idx : -1))
                        .filter((idx) => idx !== -1)
                        .pop();
                    if (index === lastIndexWithData) {
                        return 5;
                    }
                }
            },
            tension: 0.25,
            datalabels: {
                display: false
            }
        }));
    return {
        data,
        labels: labels.reverse()
    };
};

const getDataBolesPactes = (dataBoles, extraParams) => {
    const { partits } = extraParams;
    const dataString = [];
    const dataAll = [];
    const dataNum = [];
    const labels = [];
    const colors = [];

    if (__isEmpty(dataBoles?.datos?.geo?.opcions?.item) || __isEmpty(partits)) {
        return {
            dataString,
            dataNum,
            total: 0,
            labels,
            colors
        };
    }

    partits.forEach((partit) => {
        const item = dataBoles?.datos?.geo?.opcions?.item.find((item) => item.id === partit);
        if (item) {
            dataNum.push(item.mnumitems);
            dataString.push(item.numitems);
            dataAll.push({
                label: item.id,
                color: item.rgbcolor,
                percVots: item.perc,
                vots: item.vots,
                diputats: item.mnumitems,
                diputatsString: item.numitems
            });
            labels.push(item.id);
            colors.push(item.rgbcolor);
        }
    });

    return {
        dataString,
        dataNum,
        dataAll,
        total: dataNum.reduce((a, s) => a + s, 0),
        labels,
        colors
    };
};

const getDataDiputatsBarres = (dataDiputats, extraParams) => {
    let maxValue = 0;
    let limit = 0;
    const dataString = [];
    const dataAll = [];
    const dataNum = [];
    const labels = [];
    const colors = [];
    let dataBase = dataDiputats;
    if (extraParams.fase === 'seo' && !extraParams.isSecondary) {
        dataBase = extraParams.dataComparador;
    }

    if (__isEmpty(dataBase?.datos?.geo?.opcions?.item))
        return {
            dataString,
            dataNum,
            labels,
            colors
        };

    if (extraParams.isSecondary) {
        const actualLabels = extraParams?.dataActual?.labels || [];
        const secondaryItems = dataBase.datos.geo.opcions.item || [];
        const secondaryMap = new Map(secondaryItems.map((item) => [item.id, item]));
        const usedIds = new Set();
        actualLabels.forEach((itemActual, i) => {
            const itemSecondary = secondaryMap.get(itemActual);
            usedIds.add(itemActual);
            dataString.push(__isEmpty(itemSecondary) ? 0 : itemSecondary?.numitems);
            dataAll.push({
                percVots: itemSecondary?.perc,
                vots: itemSecondary?.vots,
                diputats: itemSecondary?.mnumitems,
                diputatsString: itemSecondary?.numitems
            });
            dataNum.push(__isEmpty(itemSecondary) ? 0 : itemSecondary?.mnumitems);
            labels.push(itemActual);
            colors.push(__isEmpty(itemSecondary) ? extraParams?.dataActual?.colors[i] : parseColor(itemSecondary));
            maxValue = Math.max(
                maxValue,
                __isEmpty(itemSecondary) ? 0 : itemSecondary?.mnumitems,
                extraParams?.dataActual?.dataNum?.[i] || 0
            );
        });
        secondaryItems.forEach((item) => {
            if (usedIds.has(item.id)) return;

            dataString.push(item.numitems);
            if (extraParams?.mostrarPartitsSenseDiputats || item.mnumitems > 0) {
                dataAll.push({
                    percVots: item?.perc,
                    vots: item?.vots,
                    diputats: item?.mnumitems,
                    diputatsString: item?.numitems
                });

                dataNum.push(item.mnumitems);
                labels.push(item.id);
                colors.push(parseColor(item));
            }
            maxValue = Math.max(maxValue, item.mnumitems);
        });
    } else {
        for (const partit of dataBase.datos.geo.opcions.item) {
            if (extraParams.limit && extraParams.limit === limit) break;
            if (extraParams.fase === 'seo' && (extraParams?.mostrarPartitsSenseDiputats || partit.mnumitems > 0)) {
                dataString.push(undefined);
                dataAll.push(undefined);
                dataNum.push(undefined);
                labels.push(partit.id);
                colors.push(parseColor(partit));
                maxValue = Math.max(maxValue, partit.mnumitems);
            } else if (extraParams?.mostrarPartitsSenseDiputats || partit.mnumitems > 0) {
                dataString.push(partit.numitems);
                dataAll.push({
                    percVots: partit?.perc,
                    vots: partit?.vots,
                    diputats: partit?.mnumitems,
                    diputatsString: partit?.numitems
                });
                dataNum.push(partit.mnumitems);
                labels.push(partit.id);
                colors.push(parseColor(partit));
                maxValue = Math.max(maxValue, partit.mnumitems);
            }
            limit++;
        }
    }

    return {
        dataString,
        dataAll,
        dataNum,
        labels,
        colors,
        total: dataDiputats?.datos.geo?.num_items_total,
        maxValue
    };
};
const getDataVotsBarres = (dataDiputats, extraParams) => {
    let maxValue = 0;
    let total = 0;
    let limit = 0;
    const dataString = [];
    const dataAll = [];
    const dataNum = [];
    const labels = [];
    const colors = [];
    const limitValueCondition = extraParams?.limitValueCondition;
    let dataBase = dataDiputats;
    if (extraParams.fase === 'seo' && !extraParams.isSecondary) {
        dataBase = extraParams.dataComparador;
    }
    if (__isEmpty(dataBase?.datos?.geo?.opcions?.item)) {
        return {
            dataString,
            dataNum,
            labels,
            colors
        };
    }
    if (extraParams.isSecondary) {
        let baseLabels = extraParams?.dataActual?.labels;
        if (extraParams.fase === 'seo') {
            const secondaryItems = dataBase.datos.geo.opcions.item || [];
            const secondaryMap = new Map(secondaryItems.map((item) => [item.id, item]));
            baseLabels = [...secondaryMap.keys()];
        }
        let itemsToIterate = baseLabels || [];
        if (extraParams.limit) {
            itemsToIterate = itemsToIterate.slice(0, extraParams.limit);
        }
        itemsToIterate?.forEach((itemActual, i) => {
            const itemSecondary = dataBase.datos.geo.opcions.item.find((item) => item.id === itemActual);
            const valorBarra = itemSecondary?.vots > 0 ? itemSecondary.vots : (itemSecondary?.mperc ?? 0);
            if (extraParams?.mostrarPartitsSenseDiputats || valorBarra > 0) {
                const percVotsFormat = valueFormat(extraParams.fase, itemSecondary?.perc, 2, true, false);
                dataString.push(__isEmpty(itemSecondary) ? 0 : percVotsFormat);
                dataAll.push({ percVots: itemSecondary?.perc, vots: itemSecondary?.vots, diputats: itemSecondary?.mnumitems });
                dataNum.push(__isEmpty(itemSecondary) ? 0 : valorBarra);
                labels.push(__isEmpty(itemSecondary) ? itemActual : itemSecondary.id);
                colors.push(__isEmpty(itemSecondary) ? extraParams?.dataActual?.colors[i] : parseColor(itemSecondary));
                maxValue = Math.max(maxValue, __isEmpty(itemSecondary) ? 0 : valorBarra, extraParams?.dataActual?.dataNum?.[i]);
            }
        });
    } else {
        let items = dataBase.datos.geo.opcions.item || [];
        if (limitValueCondition !== null) {
            items = items.filter((item) => item.mperc >= limitValueCondition);
        }
        for (const partit of items) {
            if (extraParams.limit && extraParams.limit === limit) break;
            if (!extraParams.mostrarPartitsSenseDiputats && partit.mnumitems === 0) break;
            const valorBarra = partit.vots > 0 ? partit.vots : (partit.mperc ?? 0);
            if (extraParams.fase === 'seo' && (extraParams?.mostrarPartitsSenseDiputats || valorBarra > 0)) {
                dataString.push(undefined);
                dataNum.push(undefined);
                dataAll.push(undefined);
                labels.push(partit.id);
                colors.push(parseColor(partit));
                maxValue = Math.max(maxValue, valorBarra);
            } else if (extraParams?.mostrarPartitsSenseDiputats || valorBarra > 0) {
                const percVotsFormat = valueFormat(extraParams.fase, partit.perc, 2, true, false);
                dataString.push(percVotsFormat);
                dataAll.push({ percVots: partit.perc, vots: partit.vots, diputats: partit.mnumitems });
                dataNum.push(valorBarra);
                labels.push(partit.id);
                colors.push(parseColor(partit));
                maxValue = Math.max(maxValue, valorBarra);
            }
            limit++;
        }
    }
    return {
        dataString,
        dataNum,
        dataAll,
        labels,
        colors,
        total,
        maxValue
    };
};

const getDataVots = (dataVots, extraParams) => {
    let total = 0;
    const dataString = [];
    const dataNum = [];
    const labels = [];
    const colors = [];

    if (__isEmpty(dataVots?.datos?.geo?.opcions?.item))
        return {
            dataString,
            dataNum,
            total,
            labels,
            colors
        };

    if (extraParams.fase === 'seo' && !extraParams.isSecondary) {
        return {
            dataString,
            dataNum: [1],
            labels,
            colors: ['#f0f3f4'],
            total: '-',
            noData: true
        };
    }

    dataVots.datos.geo.opcions.item.forEach((d) => {
        total += d.vots;
        if (extraParams?.mostrarPartitsSenseDiputats || d.mnumitems > 0) {
            dataString.push(d.perc);
            dataNum.push(d.perc);
            labels.push(d.id);
            colors.push(parseColor(d));
        }
    });

    return {
        dataString,
        dataNum,
        total,
        labels,
        colors
    };
};

const getDadesBolesMunicipiCarto = (data, extraParams) => {
    if (__isEmpty(data?.rows)) return [];
    const getCode = (code) => {
        return String(code).padStart(11, '0');
    };

    const values = data.rows.map((d) => (extraParams.tipus === 'vots' ? d.vots : d.perc_vots));
    const min = Math.min(...values);
    const max = Math.max(...values);

    const getAmplifiedValue = (value) => {
        const normalized = (value - min) / (max - min);
        return Math.pow(normalized, 1.2);
    };

    return data.rows.map((municipi, index) => {
        return {
            id: municipi.geo_codi,
            index: index + 1,
            name: municipi.geo_nom,
            value: extraParams.tipus === 'vots' ? municipi.vots : getAmplifiedValue(municipi.perc_vots),
            color: municipi.rgbcolor,
            dataAll: {
                nom: municipi.geo_nom,
                vots: municipi.vots,
                perc_vots: municipi.perc_vots,
                route: {
                    ...extraParams.route,
                    slug2: municipi.nombonic,
                    id: getCode(municipi.geo_codi)
                }
            }
        };
    });
};

const getDadesPartitsByConvocatoria = (data) => {
    return data?.opcions?.item;
};

const getDadesPartitsAmbDiputats = (data) => {
    if (__isEmpty(data?.datos?.geo?.opcions?.item)) return [];
    return data.datos.geo.opcions.item.filter((partit) => partit.mnumitems > 0);
};

const valueFormat = (fase, value, decimals = 0, percentatge = false, showZeroDecimals = true) => {
    if (fase === 'sondeig' && typeof value === 'string' && value.includes('-')) {
        return value;
    }

    const num = Number(value);
    if (isNaN(num)) return '-';

    if (fase === 'seo' && num === 0) return '-';

    const parts = num.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    let valor = parts.join(',');

    if (!showZeroDecimals && decimals > 0) {
        const decPart = parts[1];
        if (decPart && Number(decPart) === 0) {
            valor = parts[0];
        }
    }
    if (percentatge) valor += '%';

    return valor;
};

const getDataGraph = (tipus, data, extraParams = {}) => {
    switch (tipus) {
        case 'diputats': {
            return getDataDiputats(data, extraParams);
        }
        case 'vots': {
            return getDataVots(data, extraParams);
        }
        case 'diputatsBarres': {
            return getDataDiputatsBarres(data, extraParams);
        }
        case 'votsBarres': {
            return getDataVotsBarres(data, extraParams);
        }
        case 'partitsByConvocatoria': {
            return getDadesPartitsByConvocatoria(data);
        }
        case 'partitsAmbDiputats': {
            return getDadesPartitsAmbDiputats(data);
        }
        case 'bolesMunicipiCarto': {
            return getDadesBolesMunicipiCarto(data, extraParams);
        }
        case 'evolucioPartitsLinea': {
            return getDataEvolucioPartitsLinea(data);
        }
        case 'bolesPactes': {
            return getDataBolesPactes(data, extraParams);
        }
    }
};

export { getDataGraph, valueFormat };
